import module from 'contabilidad/catalogosexternos/module'
import template from './template.html'

export class contabilidadCatalogosexternosSucursalesEditarCuentasComponent {
  cuentas = []
  cuentasNuevas = []
  data
  familias
  sucursalId
  confirmando = false;

  verificarCuentasContables() {
    let cuentas_contables_index = new Map();

    //Se crea un map con todas las cuentas contables y el indice con el que estan impresas en la vista
    this.cuentas.forEach((item, index) => {
      cuentas_contables_index.set(`${index}`, item.cuentaContable);
    });

    //Se crea un array con todas las cuentas contables
    const cuentasContables = this.cuentas.map((cuenta) => cuenta.cuentaContable)
  
    //Iteramos por el map con indices y valores, seteamos todos como validos, 
    //excepto de cuando esta cuenta contable se encuentre mas de una vez en el array
    //entonces la declaramos invalida
    cuentas_contables_index.forEach((item, key) => {
      this.form[`cuenta_contable_editar${key}`].$setValidity('cuentaDuplicada', true)
      if(this.countInArray(cuentasContables, item) > 1) this.form[`cuenta_contable_editar${key}`].$setValidity('cuentaDuplicada', false)
    })
  }

  countInArray(array, what) {
    return array.filter(item => item == what).length;
  }

  verificarFamilias(index) {
    this.form['combobox' + index].$setValidity('familiaDuplicada', true)
    this.error = '';
    let familiasId = this.cuentas.map((item) => item.familiaId)
    familiasId.sort()

    for (let i = 0; i < familiasId.length; i++) {
      if (familiasId[i] == familiasId[i + 1]) this.form['combobox' + index].$setValidity('familiaDuplicada', false)
    }
  }

  agregarFamilia() {
    this.cuentas.push({
      sucursalId: this.sucursalId,
      familiaId: null,
      cuentaContable: null,
      deshabilitado: false,
      status: 1
    })

    console.info('agregar', this.cuentas)
  }

  eliminarFamilia(index) {
    if (this.cuentas.length - 1 == 0) {
      this.cuentas = []
    } else {
      this.cuentas.splice(index, 1)
    }
    this.verificarCuentasContables();
  }

  confirmar() {
    let familiasId = this.cuentas.map((item) => item.familiaId)
    let comprobarNull = (item) => item === null;

    if (familiasId.some(comprobarNull)) {
      this.error = 'Seleccione una familia'
    } else {
      this.accion = "EDITAR"
      this.text = "¿Quieres editar las cuentas contables?"
      this.confirmando = true;
    }
  }

  finalizar() {
    this.confirmando = false;
    this.onClose();
  }

}

module.component('contabilidadCatalogosexternosSucursalesEditarCuentas', {
  controller: contabilidadCatalogosexternosSucursalesEditarCuentasComponent,
  template,
  bindings: {
    cuentas: '<',
    familias: '<',
    sucursalId: '<',
    onClose: '&'
  }
})


// WEBPACK FOOTER //
// ./src/contabilidad/catalogosexternos/components/sucursales/editar/cuentas/component.js